import React from "react";
import {
    StandardModalFormGroup,
    StandardModalHelperText,
    StandardModalLabel,
    StandardModalSection,
    StandardModalSectionHeader,
    StandardModalSectionTitle,
    portalColors
} from "src/components";
import {
    CheckInCategorySelector,
    CheckInLocationSearch
} from "src/components/CheckIn";
import { CHECK_IN_CATEGORY } from "src/components/CheckIn/checkIn";

const BodyAndMindCheckInSection = ({ value, onChange, error }) => {
    const selectedCategory = value?.category || CHECK_IN_CATEGORY.LOCATION;

    const handleCategoryChange = category => {
        if (value?.category === category) {
            onChange(null);
            return;
        }

        onChange({
            ...(value || {}),
            category
        });
    };

    const handleLocationSelected = location => {
        onChange({
            ...(value || {}),
            category: selectedCategory,
            ...location
        });
    };

    return (
        <StandardModalSection>
            <StandardModalSectionHeader>
                <div>
                    <StandardModalSectionTitle>Check In</StandardModalSectionTitle>
                    <StandardModalHelperText margin="0.35rem 0 0">
                        Add a physical place to this content.
                    </StandardModalHelperText>
                </div>
            </StandardModalSectionHeader>

            <StandardModalFormGroup>
                <StandardModalLabel>Category</StandardModalLabel>
                <CheckInCategorySelector
                    value={value?.category}
                    onChange={handleCategoryChange}
                />
            </StandardModalFormGroup>

            <StandardModalFormGroup>
                <StandardModalLabel>Location</StandardModalLabel>
                <CheckInLocationSearch
                    value={value}
                    selectedCategory={selectedCategory}
                    onSelect={handleLocationSelected}
                    openOnCategoryChange
                    onClearSelectedPlace={emptyPlaceData => {
                        onChange({
                            ...(value || {}),
                            category: selectedCategory,
                            ...emptyPlaceData
                        });
                    }}
                    placeholder="Where is this location?"
                />
                {error && (
                    <StandardModalHelperText color={portalColors.danger}>
                        {error}
                    </StandardModalHelperText>
                )}
            </StandardModalFormGroup>
        </StandardModalSection>
    );
};

export default BodyAndMindCheckInSection;
